import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { Overview } from 'components/Overview'
import { InputType } from 'config'
import { useEffect, useState } from 'react'
import { getCreditDenial, updateCreditDenial } from 'services'
import { Checkbox } from 'stories/components'
import { openAuditLog } from 'utils'
import { RenderInput } from 'utils/RenderInput'
import { setLoanNumber } from 'utils/setLoanNumber'

export default function CreditDenial() {
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState<Record<string, InputType>>({})
  const [data, setData] = useState<Record<string, any>>({})
  const loanNumber = setLoanNumber()

  useEffect(() => {
    getCreditDenial().then(({ inputs, data }: { inputs: Record<string, InputType>; data: Record<string, any> }) => {
      Object.keys(data).forEach((key) => {
        inputs[key].value = data[key]
      })
      Object.keys(inputs).forEach((key) => {
        inputs[key].history = true
      })
      setInputs(inputs)
      setData(data)
    })
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(inputs)
    temp[key].value = value
    setInputs(temp)
  }

  const onBlur = async (key: string) => {
    const value = inputs[key].value
    if (data[key] == value) return

    const newData = cloneDeep(data)
    newData[key] = value
    setData(newData)

    setLoading(true)
    await updateCreditDenial(key, value)
    setLoading(false)
  }

  const onShowHistory = (key: string) => {
    const options: Record<string, any> = {
      table: 'Statement of Credit Denial',
      field: key,
      fieldLabel: inputs[key].title,
      keys: { field: key, loanNumber },
    }
    if (inputs[key].options) options.map = inputs[key].options
    openAuditLog(options)
  }

  return (
    <div className="py-6 px-2">
      <Overview title="Statement of Credit Denial" />
      <div className="max-w-screen-2xl m-auto">
        <div className="relative h-fit content-right col-span-12 md:col-span-9 bg-white p-4 rounded shadow1 mb-4">
          <LayoutLoading show={isLoading} />
          <h2 className="text-2xl font-bold flex items-center mb-5">Statement of Credit Denial</h2>
          <div className="grid gap-2 gap-y-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-1">
            {Object.keys(inputs).map((key) => {
              const input = inputs[key]

              if (['legalEntityIdentifier', 'preApproval'].includes(key)) {
                input.additionalElements = (
                  <span className={`${true ? 'text-shade-blue' : 'text-red-500'}`}>
                    <ExclamationCircleIcon className="w-4 h-4" />{' '}
                  </span>
                )
              }

              if (key === 'uli') {
                input.additionalElements = (
                  <span className="cursor-pointer hover:underline text-shade-blue" onClick={() => {}}>
                    Edit
                  </span>
                )
              }

              if ((input as any).hasNA) {
                input.additionalElements = (
                  <Checkbox id={`${key}NA`} title="N/A" onChange={() => {}} className="w-[unset]" />
                )
              }
              return (
                <div className={`col-span-${input.span || 1}`}>
                  <RenderInput
                    input={input}
                    Key={key}
                    onChange={onChange}
                    onBlur={onBlur}
                    showHistory={onShowHistory}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
